/// AJAX reques

var ajax = {};
ajax.x = function() {
  if (typeof XMLHttpRequest !== "undefined") {
    return new XMLHttpRequest();
  }
  var versions = [
    "MSXML2.XmlHttp.6.0",
    "MSXML2.XmlHttp.5.0",
    "MSXML2.XmlHttp.4.0",
    "MSXML2.XmlHttp.3.0",
    "MSXML2.XmlHttp.2.0",
    "Microsoft.XmlHttp"
  ];

  var xhr;
  for (var i = 0; i < versions.length; i++) {
    try {
      xhr = new XMLHttpRequest();
      break;
    } catch (e) {}
  }
  return xhr;
};

ajax.send = function(url, callback, method, data, async) {
  if (async === undefined) {
    async = true;
  }
  var x = ajax.x();
  x.open(method, url, async);
  x.onreadystatechange = function() {
    if (x.readyState === 4) {
      return callback(x.responseText);
    }
  };
  if (method === "POST") {
    x.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  }
  x.send(data);
};

ajax.get = function(url, data, callback, async) {
  var query = [];
  for (var key in data) {
    query.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
  }
  ajax.send(
    url + (query.length ? "?" + query.join("&") : ""),
    callback,
    "GET",
    null,
    async
  );
};

ajax.post = function(url, data, callback, async) {
  var query = [];
  for (var key in data) {
    query.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
  }
  return ajax.send(url, callback, "POST", query.join("&"), async);
};

export const fetchToProfile = () => {
  return fetch("/Account/EditProfile")
    .then(res => res.text())
    .then(res => [res, res.indexOf("<form")])
    .then(res => res[0].slice(res[1]))
    .then(resp => {
      var div = document.createElement("div");
      div.innerHTML = resp;
      return {
        email: div.querySelector("#Email").value,
        categoryId: div.querySelector("#CategoryId").value,
        name: div.querySelector("#FirstName").value,
        lastName: div.querySelector("#LastName").value,
        phone: div.querySelector("#Phone").value
      };
    })
    .catch(err => ({
      email: "",
      categoryId: "",
      name: "",
      lastName: "",
      phone: ""
    }));
};

export const fetchToimplus = () => {
  return fetch("/implus/Manage")
    .then(res => res.text())
    .then(res => [res, res.indexOf('<div class="status-icon')])
    .then(res => res[0].slice(res[1]))
    .then(res => res.slice(24, 30));
};

export const formSubmit = (event, obj, callback) => {
  event.preventDefault();
  return ajax.post("https://script.google.com/macros/s/AKfycbyWbhzvQn6-Rd0kKCbprih8jXQIZCj_x_MjYSboKVT_bmirm6IG/exec", obj, callback)


};

